import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom, timeout } from "rxjs";
import { MESSAGING_CONFIG } from "@app/config/messaging.config";
import { endpointBase } from "@app/config/api.config";

export interface PushRegistration {
  installationId: string;
  provider: string;
  token: string;
  platform: string;
  permission: string;
}

/** Backend owns user association (derived from the bearer), token replacement and delivery. */
@Injectable({ providedIn: "root" })
export class PushRegistrationService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(MESSAGING_CONFIG);

  async save(registration: PushRegistration, bearer: string): Promise<void> {
    await this.request("PUT", registration, bearer);
  }
  async remove(installationId: string, bearer: string): Promise<void> {
    await this.request("DELETE", { installationId }, bearer);
  }
  private async request(method: string, body: object, bearer: string): Promise<void> {
    const result = await firstValueFrom(this.http.request<{ status?: boolean }>(
      method, `${endpointBase}/${this.config.registrationPath}`,
      { body, headers: { Authorization: `Bearer ${bearer}` } },
    ).pipe(timeout(this.config.requestTimeoutMs)));
    if (result?.status === false) throw new Error("Push registration rejected");
  }
}
